/* eslint-disable react/prop-types */
import React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { PrimaryButton } from '@sparebankenvest/splash-ui';
import { Link } from 'gatsby';
import breakpoints from '../../utils/breakpoints';

const ButtonContainer = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
`;

const Content = styled.div`
  padding: 24px 28px;

  @media (min-width: 768px) {
    padding: 48px 60px;
  }

  ${({ theme: { hero } }) => css`
    background-color: ${hero['background-color']};
    color: ${hero.color}; ;
  `}
`;

const HeadingAddon = styled.div`
  text-transform: uppercase;
  ${({
    theme: {
      hero: { headingAddon },
    },
  }) => css`
    color: ${headingAddon.color}; ;
  `}
`;

const Heading = styled.h1`
  @media (min-width: ${breakpoints.tablet}px) {
    font-size: ${rem(48)};
  }
`;

const GatsbyLink = styled(Link)`
  color: ${({ theme }) => theme.splash.app.color};
`;

function Hero({ className }) {
  return (
    <div className={className}>
      <Content>
        <HeadingAddon>Welcome to</HeadingAddon>
        <Heading>Developer Portal</Heading>
        <p>
          Do you want to build something awesome using our services? This is the
          perfect place to get started.
        </p>
        <ButtonContainer>
          <GatsbyLink to="/getting-started">
            <PrimaryButton to="/getting-started">Getting Started</PrimaryButton>
          </GatsbyLink>
          <GatsbyLink to="/app/api">
            <PrimaryButton variant="secondary">API Reference</PrimaryButton>
          </GatsbyLink>
        </ButtonContainer>
      </Content>
    </div>
  );
}

export default styled(Hero)`
  position: relative;
  padding: 20px;

  @media (min-width: 768px) {
    padding: 40px;
  }

  &::after,
  &::before {
    position: absolute;
    content: '';
    width: 50%;
    height: 50%;
    z-index: 1000;
  }

  /* &::after {
    background: #800924;
    top: 0;
    right: 0;
  } */

  &::before {
    bottom: 0;
    left: 0;
    ${({
      theme: {
        hero: { frame },
      },
    }) => css`
      background: ${frame.background}; ;
    `}
  }

  ${Content} {
    position: relative;
    z-index: 2000;
  }

  ${HeadingAddon} {
    margin-bottom: 4px;
  }

  p {
    font-size: 22px;
    margin-bottom: 38px;
  }
`;
